"use strict";
(self["webpackChunktom_bihn"] = self["webpackChunktom_bihn"] || []).push([[926],{

/***/ 926:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ productLightbox)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _accessible360_accessible_slick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(475);
/* harmony import */ var _accessible360_accessible_slick__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_accessible360_accessible_slick__WEBPACK_IMPORTED_MODULE_1__);



// This component handles the filtration of the PDP popup image slider on variant change
function productLightbox({ wrapper }) {
  const selectors = {
    slider: '.js-image-lightbox',
  }

  const cache = {
    $slider: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.slider),
  }

  ;(function init() {
    waitForSlick(jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('sku'))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('variant-selector:change', handleVariantChange)
  })()

  function handleVariantChange(event, { variant }) {
    if (variant && variant.sku) {
      waitForSlick(variant.sku)
    }
  }

  function waitForSlick(sku) {
    const interval = setInterval(function () {
      if (cache.$slider.hasClass('slick-initialized')) {
        clearInterval(interval)
        filterImages(sku)
      }
    }, 100)
  }

  function filterImages(sku) {
    cache.$slider.slick('slickUnfilter')

    cache.$slider.slick('slickFilter', function (index, slide) {
      let $slide = jquery__WEBPACK_IMPORTED_MODULE_0___default()(slide).find('img')
      let colorData = $slide.data('colors')

      return colorData.includes(sku)
    })

    cache.$slider.slick('slickGoTo', 0, true)

    if (cache.$slider.find('img').length === 0) {
      cache.$slider.slick('slickUnfilter')
    }
  }
}


/***/ })

}]);